import { useTranslation } from 'react-i18next';

import * as S from './style';

type ExecutiveMember = {
	affiliation: string;
	name: string;
};

type ExecutiveGroup = {
	members: ExecutiveMember[];
	position: string;
};

type ExecutiveTranslation = {
	groups: ExecutiveGroup[];
	headers: {
		affiliation: string;
		name: string;
		position: string;
	};
};

const ExecutiveList = () => {
	const { t } = useTranslation();
	const executiveData = t('introduce.executives', { returnObjects: true }) as ExecutiveTranslation;

	return (
		<S.ExecutiveListContainer>
			<S.ExecutiveListItemContainer>
				<S.TablePanel>
				<S.Table>
					<S.TableHeadCell className="center">{executiveData.headers.position}</S.TableHeadCell>
					<S.TableHeadCell className="center">{executiveData.headers.affiliation}</S.TableHeadCell>
					<S.TableHeadCell className="center">{executiveData.headers.name}</S.TableHeadCell>
					{executiveData.groups.flatMap((group) =>
						group.members.map((member, index) => [
							index === 0 ? (
								<S.TableCell
									key={`${group.position}-position`}
									className="point min-height center role-cell"
									style={{ gridRow: `span ${group.members.length}` }}
								>
									{group.position}
								</S.TableCell>
							) : null,
							<S.TableCell key={`${group.position}-${member.name}-${index}-affiliation`} className="center">
								{member.affiliation}
							</S.TableCell>,
							<S.TableCell key={`${group.position}-${member.name}-${index}-name`} className="center">
								{member.name}
							</S.TableCell>,
						])
					)}
				</S.Table>
				</S.TablePanel>
			</S.ExecutiveListItemContainer>
		</S.ExecutiveListContainer>
	);
};

export default ExecutiveList;
